import Tooltip from '@material-ui/core/Tooltip';
import type { CSSProperties } from 'react';
import React from 'react';

interface IProps {
  count: number | string;
  final?: string;
  style?: CSSProperties;
  title?: string;
  after?: React.ReactNode;
  children?: React.ReactNode;
}

const Truncate = ({ count, final = '...', style, title, children, after }: IProps) => {
  const cropText = (value: string) => {
    value = value.slice(0, Number(count));
    return `${value.trim()}${final}`;
  };

  const isString = typeof children === 'string';
  const shouldCrop = isString && children.length >= count;

  return (
    <div style={style} title={title}>
      {shouldCrop ? (
        <Tooltip title={children} placement='top' arrow>
          <span>{cropText(children)}</span>
        </Tooltip>
      ) : (
        children
      )}
      {after}
    </div>
  );
};

export default Truncate;
